import {
  PitchDistance,
  PitchPosition,
} from '@collector/mobile-feature-goal-and-pitch-positions'
import {
  HandballAttributeId,
  HandballThrowSavedAttribute,
} from '@collector/sportsapi-client-legacy'

export const pitchDistanceAttributeMap = new Map<
  PitchDistance,
  HandballAttributeId
>([
  ['6m', HandballThrowSavedAttribute.SixMeter],
  ['9m', HandballThrowSavedAttribute.NineMeter],
])

export const pitchPositionAttributeMap = new Map<
  PitchPosition,
  HandballAttributeId
>([
  ['left', HandballThrowSavedAttribute.LeftSide],
  ['right', HandballThrowSavedAttribute.RightSide],
  ['left-wing', HandballThrowSavedAttribute.LeftWing],
  ['right-wing', HandballThrowSavedAttribute.RightWing],
  ['center', HandballThrowSavedAttribute.Center],
])
